import React, { useState } from 'react'
import { Grid } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import { Card, CardBody } from 'reactstrap'
import { useDebounce } from '../../../utils/searchDebouncer'
import ContentWrapper from '../../../components/Layout/ContentWrapper'
import { downloadCsv, downloadZipDocs, useApplicantHistory, useGetApplicants } from '../applicantsRequests'
import ApplicantChart from '../Components/ApplicantsChart'
import Filters from '../Components/Filters/Filters'
import OpenPosition from '../Components/Positions/OpenPosition'
import Statuses from '../Components/Statuses'
import { statusEnumSQ } from '../enums/statusEnumSQ'
import { applicantTableColumns } from '../utils/tableColumns'
import { applicantTableOptions } from '../utils/tableOptions'

const ApplicantsComponent = () => {
  const [query, setQuery] = useState({
    status: 'new',
    dateFrom: null,
    dateTo: null,
    name: '',
    page: 0,
    limit: 10,
    location: [],
    jobPosition: '',
    sortByStatus: false
  })

  const searchTxt = useDebounce(query.name)
  const { data, isLoading, isFetching } = useGetApplicants({ ...query, name: searchTxt })
  const loading = isLoading || isFetching
  const { applicants = [], statistics: statuses = [], currentStatistics = [], records } = data || {}
  const { data: history } = useApplicantHistory(query)
  const applicantHistory = history?.data || {}

  // 1. Grab the exact key order from your enum:
  const order = Object.keys(statusEnumSQ)

  // 2. Create a sorted copy of statuses and filter out 'all':
  const sortedStatuses = [...statuses].filter((status) => status._id !== 'all').sort((a, b) => order.indexOf(a._id) - order.indexOf(b._id))

  return (
    <ContentWrapper style={{ width: '100%' }}>
      <div className='content-heading'>
        <div>List of applicants</div>
      </div>

      <OpenPosition />
      <ApplicantChart applicantHistory={applicantHistory} />

      <Grid
        marginY={3}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap'
        }}
      >
        {sortedStatuses.map((btn, i) => (
          <Statuses key={btn._id} statusEnumSQ={statusEnumSQ} query={query} setQuery={setQuery} btn={btn} len={sortedStatuses.length} currentStatistics={currentStatistics} />
        ))}
      </Grid>

      <Card className='shadow'>
        <CardBody>
          <Filters setQuery={setQuery} query={query} />
          <div className={loading ? 'whirl standard' : null} style={{ position: 'relative' }}>
            <MUIDataTable
              title={statusEnumSQ[query.status] || 'Applicants'}
              columns={applicantTableColumns}
              options={applicantTableOptions(
                records,
                loading,
                setQuery,
                () => downloadCsv(query, searchTxt),
                () => downloadZipDocs(query),
                query.sortByStatus,
                query.status
              )}
              data={applicants}
            />
          </div>
        </CardBody>
      </Card>
    </ContentWrapper>
  )
}

export default ApplicantsComponent
